import httpClient from "@/core/axios";

export default {
    namespaced: true,
    state: {
        taxon: null,
        breadcrumbs: [],

        taxons: []
    },
    getters: {
        taxon(state) {
            return state.taxon;
        },
        breadcrumbs(state) {
            return state.breadcrumbs;
        },

        taxons(state) {
            return state.taxons;
        }
    },
    actions: {
        async fetchTaxons(context) {
            await context.commit("FLUSH_TAXONS");

            return httpClient
                .get(`/api/guest/app/:app_uuid/knowledge/taxons`)
                .then(data => context.commit("SET_TAXONS", data));
        },
        async fetchTaxon(context, { slug }) {
            await context.commit("FLUSH_TAXON");

            return httpClient
                .get(`/api/guest/app/:app_uuid/knowledge/taxons/${slug}`)
                .then(data => context.commit("SET_TAXON", data));
        }
    },
    mutations: {
        SET_TAXONS(state, data) {
            state.taxons = data;
        },
        FLUSH_TAXONS(state) {
            state.taxons = [];
        },
        SET_TAXON(state, data) {
            state.taxon = data.taxon;

            state.breadcrumbs = [
                { name: "Knowledge", label: data.taxonomy.name }
            ];
            state.breadcrumbs.push(
                ...data.breadcrumbs.map(taxon => {
                    return {
                        label: taxon.name,
                        name: "KnowledgeTaxon",
                        params: { slug: taxon.slug }
                    };
                })
            );
        },
        FLUSH_TAXON(state) {
            state.taxon = null;
            state.breadcrumbs = [];
        }
    }
};
